import { render, staticRenderFns } from "./dataInfo.vue?vue&type=template&id=3319285b&scoped=true&"
import script from "./dataInfo.vue?vue&type=script&lang=js&"
export * from "./dataInfo.vue?vue&type=script&lang=js&"
import style0 from "./dataInfo.vue?vue&type=style&index=0&id=3319285b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3319285b",
  null
  
)

export default component.exports